import { Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { Box } from '@mui/system';
import * as React from 'react';
import { useNavigate, Link } from 'react-router-dom';

import Grid, { QueryOptions } from '../Grid';
import { AppContext } from '../../AppContext';

const columns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'name',
    filterable: true,
    sortable: true,
    renderCell: ({row}: any) => (<Link to={`/leads/${row?.id}`}>{row?.name}</Link>)
  },
  { field: 'category', width: 150, filterable: true, sortable: true },
  { field: 'status', width: 150, filterable: true, sortable: true },
  { field: 'country', width: 150, filterable: true, sortable: true },
  { field: 'manager.name', headerName: 'manager', width: 150, filterable: true, sortable: true, valueGetter: (_value, row) => row?.manager?.name},
];


export default function LeadsPage() {
  const {client, notificationsService, user} = React.useContext(AppContext);
  const navigate = useNavigate();

  const fetchData = async (options: QueryOptions) => {
    const result = await client<any, any>({
      event: 'leads.getAll',
      data: options as any
    })

    if (result.success) {
      return result.value
    } else {
      notificationsService.notify({
        severity: 'error',
        message: `Error: ${JSON.stringify(result.errors)}`
      });

      return {data: [], pageInfo: {}}
    }
  };


  return <Box sx={{display: 'flex', flexDirection: 'column', height: '100%' }}>
    <Box sx={{marginBottom: 1}}>
      <Button
        variant="contained"
        onClick={() => navigate('/leads/new')}
      >
        CREATE NEW LEAD
      </Button>
      {
        user.role === "admin"
        ? (<Button
          variant="contained"
          onClick={() => navigate('/leads/report')}
          sx={{marginLeft: 1}}
        >
          Report
        </Button>)
        : <></>
      }
    </Box>
    <Box sx={{flexGrow: 1}}>
      <Grid
        cacheName={'leads'}
        columns={columns}
        fetchData={fetchData}
        onRowClick={(id) => {}}
        showSearch={true}
      />
    </Box>
  </Box>
}
